import DuckEntity from './DuckEntity';
import DuckEntityForm from './DuckEntityForm';
import FilteredContactList from "ducks/FilteredContactList";
import BaseUserJobs from './BaseUserJobs';
import CursorPageableDuck from './CursorPageableDuck';

import { entity as customerOauthConfig } from './customerOauthConfig';

import PageableDuck from 'ducks/PageableDuck';
import taggableDuck from "./taggableDuck";

// Ducks exported from here will automatically have their reducers included in redux (see reducers/index.js).
// Easiest way to add a duck is to export it here, then call `import {duckname) from '.../ducks'` in whatever component references it
export { authPaymentAccounts } from './authPaymentAccounts';
export { authPaymentMethods } from './authPaymentMethods';

export { blackbaudSkyConfig } from './blackbaudSkyConfig';
export { quickbooksConfig } from './quickbooksConfig';


export { entity as billingAccountContacts } from './billingAccountContacts';
export { entity as billingContacts, billingContactForm } from './billingContacts';
export { entity as billingStudents } from './billingStudents';
export { entity as billingFinancialSplit } from './billingFinancialSplit';
export { entity as splitDeposits } from './splitDeposits';
export { entity as forms } from './forms';

export { customerLedgerItems, customerLedgerItemForm } from './customerLedgerItems';

export const checklistAnswerLinks = new DuckEntity('checklistAnswerLinks');
export const commonForms = new DuckEntity('commonForms');
export const activities = new DuckEntity('activities', { jsonRoot: 'activity' });
export const activityItems = new DuckEntity('activityItems');
export const activityItemsForm = new DuckEntityForm('activityItemsForm', activityItems, { initialState: { name: '' } });
export const billingAccounts = new DuckEntity('billingAccounts');
export const billingAccountAccesses = new DuckEntity('billing_account_accesses', { jsonRoot: 'billing_account_access' });
export const billingAccountPotentialPayers = new DuckEntity('billing_account_potential_payers');
export const billingAccountForm = new DuckEntityForm('billingAccountForm', billingAccounts, { initialState: { owners: [] } });
export const billingLedgerItems = new FilteredContactList(new DuckEntity('billingLedgerItems'));
export const inSchoolPayments = new FilteredContactList(new DuckEntity('inSchoolPayments'));
export const billingReports = new FilteredContactList(new DuckEntity('billingReports'));
export const exportableReportConfigs = new DuckEntity('exportableReportConfigs');

export const billingPayers = new DuckEntity('billing_payers');
export const commonChecklistGroups = new DuckEntity('commonChecklistGroups');
export const sharedPortalSherlockUsers = new DuckEntity('sharedPortalSherlockUsers');
export const sharedPortalConfigs = new DuckEntity('sharedPortalConfigs');
export const sharedPortalConfigForm = new DuckEntityForm('sharedPortalConfigForm', sharedPortalConfigs);
export const customerNotes = new DuckEntity('customerNotes');
export const customerNoteForm = new DuckEntityForm('customerNoteForm', customerNotes);
export const deletedContacts = new DuckEntity('deletedContacts');
export const formInboxItems = new PageableDuck('formInboxItems');
export const grades = new DuckEntity('grades');
export const schoolYears = new DuckEntity('schoolYears');
export const gradesSchoolYears = new DuckEntity('gradesSchoolYears');
export const ssatbComponents = new DuckEntity('ssatbComponents');
export const ssatbFields = new DuckEntity('ssatbFields');
export const testScores = new DuckEntity('testScores');
export const userJobs = new DuckEntity('userJobs');
export const bulkActionEvents = new DuckEntity('bulkActionEvents');
export const search = new DuckEntity('search');
export const savedSearches = taggableDuck(new DuckEntity('savedSearches'));
export const rateCards = new DuckEntity('rateCards');
export const billingCategoryReport = new DuckEntity('billingCategoryReport', { jsonRoot: 'billing_category_report' });
export const billingDashboard = new DuckEntity('billingDashboard', { jsonRoot: 'billing_dashboard' });
export const historicalOverdueReport = new DuckEntity('historicalOverdueReport', { jsonRoot: 'historical_overdue_report' });
export const emailHistories = new FilteredContactList(new DuckEntity('email_histories', { jsonRoot: 'email_history' }));
export const powerSchoolContacts = new DuckEntity('power_school_contacts');
export const bulkPDFJob = BaseUserJobs('bulkPdfJobs');
export const bulkPDFJobsMeta = new DuckEntity('bulkPDFJobsMeta', { apiPath: 'user_jobs/bulk_pdf_jobs/meta', jsonRoot: 'pages', jsonIndexRoot: 'pages' });
export const bulkDownloadJob = BaseUserJobs('bulkDownloadJob');
export const bulkCSVJob = BaseUserJobs('contactListCsvExportJobs');
export const bulkDownloadPortraitsJob = BaseUserJobs('bulkDownloadPortraitsJob');
// export const bulkCounterSignContracts = new DuckEntity('bulk_countersign')
export const feeGroups = new DuckEntity('fee_groups');
export const fees = new DuckEntity('fees');
export const feeRules = new DuckEntity('fee_rules');
export const listPageConfigs = new DuckEntity('listPageConfigs');
export const listPageConfigsFields = new DuckEntity('listPageConfigsFields');
export const projectedIncomeReport = new DuckEntity('projectedIncomeReport', { jsonIndexRoot: 'projected_income_report' });
export const emailOpenRates = new DuckEntity('emailOpenRates', { jsonIndexRoot: 'email_open_rates' });
export const permissionGroups = new PageableDuck('permissionGroups');
export const admins = new PageableDuck('admins');
export const revenueRecognitionReport = new DuckEntity('revenueRecognitionReport', { jsonIndexRoot: 'revenue_recognition_report' });
export const monthlyIncrementalReport = new DuckEntity('monthlyIncrementalReport', { jsonIndexRoot: 'monthly_incremental_report' });
export const reviewContacts = new FilteredContactList(new DuckEntity('reviewContacts'));
export const reviewContactsFilters = new DuckEntity('reviewContactsFilters', { apiPath: 'review_contacts/filters', jsonRoot: 'filter', jsonIndexRoot: 'filters' });
export const reviewSchoolYears = new DuckEntity('reviewSchoolYears');
export const reviewChecklistItems = new DuckEntity('reviewChecklistItems');
export const reviewActivityItems = new DuckEntity('reviewActivityItems');
export const reviewConfigs = new DuckEntity('reviewConfigs');
export const reviewFields = new DuckEntity('reviewFields');
export const reviewReaders = new DuckEntity('reviewReaders');
export const sharedPortalHouseholds = new DuckEntity('households');
export const sharedPortalIntakes = new DuckEntity('intakes');
export const sharedPortalSchools = new DuckEntity('schools');
export const sharedPortalSchoolGroups = new DuckEntity('groups');
export const sharedPortalStudents = new DuckEntity('students');
export const sharedPortalParents = new DuckEntity('parents');
export const sharedPortalUsers = new DuckEntity('users');
export const sharedPortalDashboardSchools = new DuckEntity('dashboardSchools');
export const searchConfigsFields = new DuckEntity('searchConfigsFields');
export const selectedFields = new DuckEntity('selectedFields');
export const searchConfigsGroupingFields = new DuckEntity('searchConfigsGroupingFields');
export const counterSignContracts = new DuckEntity('countersign_contracts');
export const chargeRules = new DuckEntity('chargeRules');

export { reviewCriteria } from './reviewCriteria';
export { entity as apiCredentials } from './apiCredentials';
export { entity as apiUsers } from './apiUsers';
export { entity as appointments } from './appointments';
export { entity as calendars } from './calendars';
export { entity as combinedFunnelReport } from './combinedFunnelReport';
export { entity as combinedEnrollmentTotalsReport } from './combinedEnrollmentTotalsReport';

export { entity as contacts } from './contacts';
export { entity as users } from './users';
export { entity as checklistAnswers } from './checklistAnswers';
export { entity as customers } from './customers';
export { entity as customerInfos } from './customerInfos';
export { entity as delayedJobs } from './delayedJobs';
export { exportConfigs } from './exportConfigs';
export { entity as fields } from './fields';
export { default as flashMessages } from './flashMessages';
export { default as modals } from './modals';
export { entity as contracts } from './contracts';
export { entity as orders } from './orders';
export { entity as orderTransactions } from './orderTransactions';
export { entity as refunds } from './refunds';
export { billingCategories } from './billingCategories';
export { sharedPortalGroups } from './sharedPortalGroups';
export { entity as billingCategoryGroups } from './billingCategoryGroups';
export { billingConfigs, billingConfigForm } from './billingConfigs';
export { billingItems, autopayInstallments, billingItemForm } from './billingItems';
export { contactInstallmentSchedules, contactInstallmentSchedulesForm } from './contactInstallmentSchedules';
export { entity as billingPayments } from './billingPayments';
export { entity as bulkAddTransactionJobs } from './bulkAddTransactionJob';
export { entity as paymentProfiles, paymentProfileForm } from './paymentProfiles';
export { paymentPlans, paymentPlanForm } from './paymentPlans';
export { paymentPlanSchedules, paymentPlanSchedulesForm } from './paymentPlanSchedules';
export { entity as schedules } from './schedules';
export { entity as statuses } from './statuses';
export { stripePayouts } from './stripePayouts';
export { stripeBalanceTransactions } from './stripeBalanceTransactions';
export { entity as submitContractsJob } from './submitContractsJob';
export { entity as tags } from './tags';
export { entity as tasks } from './tasks';
export { entity as uploadFields } from './uploadFields';
export { entity as paymentVerifications } from './paymentVerifications';
export { billingImportJobs } from './billingImportJobs';
export { disputes } from './disputes';
export { entity as globalWidgets } from './globalWidgets';
export { entity as veracrossConfig } from './veracrossConfig';
export { entity as reviewDocuments } from './reviewDocuments';
export { entity as reviewSettings } from './reviewSettings';
export { entity as reviews } from './reviews';
export { entity as contractFees } from './contract_fees'

export { entity as customerGenderConfig } from './customerGenderConfig';

export { entity as customerOauthConfig } from './customerOauthConfig';
export const customerOauthConfigForm = new DuckEntityForm('customerOauthConfigForm', customerOauthConfig, {
  initialState: {
    oauth2_admin_domains: null, oauth_provider: null
  }
});
